import React, {useState} from 'react'
import styles from "../../../styles/account-settings.module.css"
import checked from "../../../assets/images/Checked-box.png"
import {Image} from "react-bootstrap";
import TokenService from "../../../services/token.service";
import PrimaryModal from "../../common/modals/primary-modal";
import InfoModal from "../../common/modals/info-modal";
import AccountSettingsService from "../../../services/account-settings.service";

const CancelAccount = () => {
    const userRole = TokenService.getUser()?.role
    const {useHandleDeleteAccountService} = AccountSettingsService()
    const [isOpen,setIsOpen] = useState(false)
    const {isLoading,mutate,isSuccess} = useHandleDeleteAccountService()

    const handleAccountConfirmationModal = (isModalOpen) => {
        setIsOpen(isModalOpen)
    }
    return(
        <>
            <section className={styles.account__details__wrapper}>
               <div className={styles.cancel__account}>
                   <div className={styles.account__role}>
                       <Image src={checked} alt={'checked'}/>
                       <p className={styles.role__info}>Your account is {userRole === "Renter" ? "a" : "an"} {userRole} account</p>
                   </div>
                   <h4>Permanently delete and close your account</h4>
                   <p className={styles.delete__info}>Account deletion is permanent, and you will not be able to
                       reactivate your account or retrieve any content after the deletion.</p>
                   <button onClick={() => handleAccountConfirmationModal(true)}>Cancel Account</button>
               </div>
            </section>
            {isOpen &&
                <PrimaryModal
                    size={"lg"}
                    customClass={"half__modal"}
                    isOpen={isOpen}
                    modalContent={
                        <InfoModal
                            handleModalClose={handleAccountConfirmationModal}
                            isLoading={isLoading}
                            mutate={mutate}
                            isSuccess={isSuccess}
                            title={"Account Deletion"}
                            description={"Are you sure you want to delete your account? This action cannot be undone."}
                            confirmButtonText={"Delete"}
                        />}
                />
            }
        </>
    )
}
export default CancelAccount;
